import { render, staticRenderFns } from "./DistributorDelete.vue?vue&type=template&id=0a1e8dae&"
import script from "./DistributorDelete.vue?vue&type=script&lang=js&"
export * from "./DistributorDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports